import { Grid, Hidden } from "@material-ui/core";
import { Box } from '@mui/material';
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { UsersSummary } from '../admin/UsersSummary';
import { DEFAULT_LOCALE, ROLE } from '../util/constant';
import { LatestAlerts } from './LatestAlerts';
import StrategyPerformance from './StrategyPerformance';

export const showCurrency = (amt, showCurrencySymbol = true) => {
  if (isNaN(amt) || !isFinite(amt))
    return 0
  if (showCurrencySymbol)
    return amt?.toLocaleString(DEFAULT_LOCALE, { style: 'currency', currency: 'INR', maximumFractionDigits: 0 })
  return amt?.toLocaleString(DEFAULT_LOCALE, { currency: 'INR', maximumFractionDigits: 0 })

}

export const getDateDaysAgo = daysAgo => moment(Date.now()).subtract(daysAgo, 'day').format("YYYY-MM-DD")

const Dashboard = ({ user, whose }) => {
  const [activeUsersSummary, setActiveUsersSummary] = useState()
  const [fromDate, setFromDate] = useState(getDateDaysAgo(5))
  const [latestTradesSuccessRatio, setLatestTradesSuccessRatio] = useState()
  const [latestAlertsAndStrategyPerformance, setLatestAlertsAndStrategyPerformance] = useState({})
  const [latestAlertsLoading, setLatestAlertsLoading] = useState(false)
  const isAdmin = user?.role === ROLE.ADMIN;
  const history = useHistory();


  useEffect(() => {
    setLatestAlertsLoading(true)
    fetch(`/algo-trading/public/api/latest-alerts-and-strategy-performance?fromDate=${fromDate || getDateDaysAgo(5)}`, {
      headers: new Headers({
        'Authorization': user?.credential || ''
      }),
    }).then(r => {
      if (r.status >= 400) {
        return
      }
      r.text()
        .then(value => {
          setLatestAlertsAndStrategyPerformance(JSON.parse(value));
        })
    }
    ).catch(error => {
      console.log(error);
    }).finally(() => setLatestAlertsLoading(false));

    return () => setLatestAlertsAndStrategyPerformance()
  }, [user, fromDate])


  useEffect(() => {
    if (user === undefined || Object.keys(user).length === 0) {
      history.push('/')
    }
  }, [user])

  useEffect(() => {
    fetch('/algo-trading/public/api/active-users-combined-summary', {
      headers: new Headers({
        'Authorization': user.credential
      }),
    }).then(r => {
      if (r.status >= 400) {
        history.push('/')
        return
      }
      r.text()
        .then(value => {
          setActiveUsersSummary(JSON.parse(value));
        })
    }
    ).catch(error => {
      console.log(error);
      history.push('/')
    });

    if (isAdmin)
      getLatestTradesEarningsPercent()

    return () => {
      setActiveUsersSummary()
      setFromDate()
    }
  }, [user])

  const getLatestTradesEarningsPercent = () => {
    fetch('/algo-trading/api/admin/latest-trades-earnings', {
      headers: { 'Authorization': user.credential },
    }).then(r => {
      if (r.status >= 400) {
        history.push('/')
        return
      }
      r.text()
        .then(value => {
          setLatestTradesSuccessRatio(JSON.parse(value));
        })
    }
    ).catch(error => {
      console.log(error);
      history.push('/')
    });
  }

  return (
    <Box sx={{
      backgroundImage: 'url(background.jpeg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}>
      <Grid container justifyContent='space-around' style={{ padding: '20px' }}>
        {isAdmin &&
          <Paper component={Grid} item elevation={4} style={{ padding: 20, margin: 5 }}>
            <Grid item>
              <Typography align='center'
                variant='h2'>{isNaN(activeUsersSummary?.totalActiveUsers) ? 0 : activeUsersSummary?.totalActiveUsers}</Typography>
            </Grid>
            <Grid item>
              <Typography align='center'>Active Users</Typography>
            </Grid>
          </Paper>
        }
        <Paper component={Grid} item elevation={4} style={{ padding: 20 }}>
          <Grid item>
            <Hidden xsDown>
              <Typography align='center' variant='h2'>{showCurrency(activeUsersSummary?.totalInvestment)}</Typography>
            </Hidden>
            <Hidden smUp>
              <Typography align='center' variant='h4'>{showCurrency(activeUsersSummary?.totalInvestment)}</Typography>
            </Hidden>
          </Grid>
          <Grid item>
            <Typography align='center'>Total Invested Amount</Typography>
          </Grid>
        </Paper>
        {isAdmin && latestTradesSuccessRatio?.totalCount > 0 &&
          <Paper component={Grid} item elevation={4} style={{ padding: 20, margin: 5 }}>
            <Grid item>
              <Typography align='center' variant='h2'>
                {(latestTradesSuccessRatio?.successCount * 100 / latestTradesSuccessRatio?.totalCount)?.toFixed(2)}<span
                  style={{ fontSize: 'medium' }}>%</span>
              </Typography>
            </Grid>
            <Grid item>
              <Typography align='center'>Success trades ratio &nbsp;
                ({latestTradesSuccessRatio?.successCount}/{latestTradesSuccessRatio?.totalCount})</Typography>
            </Grid>
          </Paper>
        }
      </Grid>
      <Grid container direction={"row"} justifyContent='space-around' style={{ padding: 20 }}>
        {isAdmin &&
          <Paper component={Grid} item elevation={10} xs={11} md={5} sm={5} lg={5} style={{ margin: 5 }}>
            <UsersSummary user={user} />
          </Paper>
        }
        <Paper component={Grid} item elevation={10} xs={11} md={5} sm={5} lg={5}>
          <LatestAlerts
            user={user}
            fromDate={fromDate}
            setFromDate={setFromDate}
            latestAlerts={latestAlertsAndStrategyPerformance?.latestAlerts}
            isLoading={latestAlertsLoading} />

        </Paper>
      </Grid>
      <Grid container direction={"row"} justifyContent='space-around' style={{ padding: 20 }}>
        <Paper component={Grid} item elevation={10} xs={11} md={5} sm={5} lg={5}>
          <StrategyPerformance
            user={user}
            fromDate={fromDate}
            strategyPerformance={latestAlertsAndStrategyPerformance?.strategyPerformance}
            isLoading={latestAlertsLoading} />
        </Paper>
        <Grid item xs={11} md={5} sm={5} lg={5} />
      </Grid>
    </Box >
  );
}

export default Dashboard;